import { Locale } from 'date-fns'
import { de, enUS, zhCN } from 'date-fns/locale'

export const dateFnsLocaleMap: Record<string, Locale> = {
  en: enUS,
  de,
  // date-fns names Simplified Chinese 'zh-CN'; our i18next code is 'zh'.
  zh: zhCN
}
